import React from 'react';

import { useDragonBallTakeoverExposureEligibility } from 'features/app-takeover/hooks/use-app-takeover';
import { MenuTabsWrap } from 'features/menu/components/menu-tabs';
import { MainMenuPage } from 'features/menu/pages/main-menu-page';
import { MainMenuPageV2 } from 'features/menu/pages/main-menu-page-v2';
import { useStoreRequired } from 'features/store/hooks/use-store-required';

import { useDragonBallExperiment } from 'experiments/use-dragon-ball-experiment';
import { useEnableUnifiedMenu } from 'hooks/use-enable-unified-menu';

export default function MenuScreen() {
  useStoreRequired();

  return <MenuInner />;
}

const MenuInner = React.memo(() => {
  const enableUnifiedMenu = useEnableUnifiedMenu();
  const { isActive: isDragonBallTakeoverActive } = useDragonBallTakeoverExposureEligibility();

  useDragonBallExperiment(!isDragonBallTakeoverActive);

  return <MenuTabsWrap>{enableUnifiedMenu ? <MainMenuPageV2 /> : <MainMenuPage />}</MenuTabsWrap>;
});
